import * as oPath from '../../../Lib/Object/Path/Mutable';
import { createSlice } from '@reduxjs/toolkit';
import { InitAction, TestPagesState } from './types';
import { AddArrayEntryAction, RemoveArrayEntryAction, SetValueAction } from '../DataSync/types';
import { isNil } from 'ramda';

const name = 'testPages';

const initialState: TestPagesState = {
  testPage: undefined,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    init: (state, action: InitAction) => {
      state.testPage = action.payload.testPage;
      state.config = action.payload.config;
      state.data = action.payload.data ?? {};
    },
    addArrayEntry: (state, action: AddArrayEntryAction) => {
      const { payload: { index, name, data = {} } = {} } = action;
      oPath.createPathIfNotExists(state, `data.${name}`);
      let oldValue = oPath.get(state, `data.${name}`);
      if (!oldValue) oPath.set(state, `data.${name}`, [data], true);
      else oldValue.splice(index, 0, data);
    },
    removeArrayEntry: (state, action: RemoveArrayEntryAction) => {
      const {
        payload: { index, name },
      } = action;
      oPath.createPathIfNotExists(state, `data.${name}`);
      const array = oPath.get<Array<any>>(state, `data.${name}`);
      if (isNil(array)) {
        oPath.set(state, `data.${name}`, [], true);
      } else {
        array.splice(index, 1);
      }
    },
    setValue: (state, action: SetValueAction) => {
      const { payload: { name, value } = {} } = action;
      oPath.set(state, `data.${name}`, value, true);
    },
  },
});

const { actions, reducer } = slice;
export { actions, reducer };
